import styled from 'styled-components/macro';
import { TYPOGRAPHY } from 'styleguide';

const Info = styled.div`
  margin-top: 4px;
  margin-bottom: 24px;
  ${TYPOGRAPHY.title}
`;

export default Info;
